import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {KTSVG, useDebounce} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'

import './UserList.scss'
import {ProfileDetailData} from '../../../Redux/AdminPanel/ProfileDetailsSlice'
import {
  fetchAllUser,
  getAllUser
} from './UserListSlice/UserListSlice'
import {AuthenticateUser, StatusColor} from '../../../Utils/_helpers/RoleAndPermission'
import NodataYet from '../../../Components/NodataYet'

const AllSmartSMSUserList = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [checkList, setCheckList] = useState<any>([])
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  const userList: any = useSelector(getAllUser)

  const debouncedSearchTerm = useDebounce(page?.search, 500)

  useEffect(() => {
    if (page.page || page.size) {
      dispatch(fetchAllUser(page))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, page.page, page.size])

  const handleCheckAll = () => {
    if (checkList?.length === userList?.items?.length) {
      setCheckList([])
    } else {
      let list = userList?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }
 
  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  useEffect(() => {
    if (confirm === true) {
      setCheckList([])
      setConfirm(false)
    }
  }, [confirm])


  const DeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete this user? '}
        confirm={() => setConfirm(true)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open]
  )
  
  return (
    <>
      {DeleteConfirmation}
      <div className={`sub-accountstable`}>
        <div className='card-header border-0 pt-5'>
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a user'
          >
            <div className='d-flex align-items-center position-relative my-1'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search user'
                value={page?.search}
                onChange={(e) => setPage({...page, search: e.target.value, page: 1, size: 10})}
              />
            </div>

            {/* {AuthenticateUser('create-user') && (
              <button type='button' className='btn btn-primary' onClick={() => setSubUser(true)}>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                Add User
              </button>
            )} */}
          </div>
        </div>
        {userList?.items?.length > 0 ? (
          <>
            <div className='card-body py-3'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='w-25px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value='ALL'
                            data-kt-check='true'
                            data-kt-check-target='.widget-9-check'
                            checked={checkList?.length >= userList?.items?.length}
                            onChange={handleCheckAll}
                          />
                        </div>
                      </th>
                      <th className='min-w-150px'>USER</th>
                      <th className='min-w-140px'>COMPANY</th>
                      <th className='min-w-140px'>PHONE</th>
                      <th className='min-w-140px'>STATUS</th>
                      <th className='min-w-150px'>PAYMENT TYPE</th>
                      <th className='min-w-120px'>INDUSTRY</th>
                      <th className='min-w-150px'>WEBSITE</th>
                      <th className='min-w-150px'>SUBSCRIPTION</th>
                      <th className='min-w-150px'>CREATED ON</th>
                      <th className='min-w-100px text-end'>ACTIONS</th>
                    </tr>
                  </thead>

                  <tbody>
                    {userList?.items?.map((data: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              value={data?._id}
                              checked={checkList?.includes(data?._id)}
                              onChange={handleCheck}
                            />
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center'>
                            <div
                              onClick={() => {
                                if (AuthenticateUser('edit-user')) {
                                  dispatch(ProfileDetailData(data?._id))
                                  navigate(`/user-profile`)
                                }
                              }}
                              className='symbol symbol-45px me-5 cursor-pointer'
                            >
                              {data?.avatar && data?.avatar !== 'undefined' ? (
                                <img src={data?.avatar} alt='' />
                              ) : (
                                <span className='circle1'>{`${
                                  data?.firstName !== undefined && data?.firstName !== ''
                                    ? data?.firstName?.split('')?.[0]?.toUpperCase() ?? ''
                                    : ''
                                }${
                                  data?.lastName !== undefined && data?.lastName !== ''
                                    ? data?.lastName?.split('')?.[0]?.toUpperCase() ?? ''
                                    : ''
                                }`}</span>
                              )}
                            </div>
                            <div className='d-flex justify-content-start flex-column'>
                              <span
                                className='text-dark fw-bolder text-hover-primary fs-6'
                              >
                                {`${data?.firstName} ${data?.lastName}`}
                              </span>
                              <span
                                className='text-muted fw-bold text-muted d-block fs-7'
                              >
                                {data?.email}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {data?.companyName}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {data?.phone}
                          </span>
                        </td>
                        <td>
                          <span className={`badge badge-light-${StatusColor?.[data?.status]}`}>
                            {data?.status}
                          </span>
                        </td>
                        <td>{data?.accountType}</td>
                        <td>
                          <b> {data?.industry?.toUpperCase()} </b>
                        </td>
                        <td>
                          <b> {data?.companyUrl} </b>
                        </td>
                        <td>
                          <b> {data?.subscription?.name ?? '-'} </b>
                        </td>
                        <td>
                          <span
                            className='text-dark fw-bolder text-hover-primary d-block fs-6'
                          >
                            {moment(data?.createdAt).format('DD/MM/YYYY')}
                          </span>
                        </td>
                        <td className='text-end'>
                          -
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='abcd '>
                <select
                  value={page?.size}
                  className='SelectSize'
                  onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={userList?.total}>ALl</option>
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={userList?.totalPages}
                  onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default AllSmartSMSUserList
